import { useGetProcedures } from '@vindr/services/actions/procedure.api';
import { DefinedColumns } from '@vindr/services/interfaces';
import { ActionIcon } from '@vindr/ui';
import { useTranslation } from 'react-i18next';

interface ProcedureColumnsType
  extends DefinedColumns<ReturnType<typeof useGetProcedures>['data']['data'][number]> {}

const useProcedureColumns = ({ onRemove }): ProcedureColumnsType[] => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: t('Procedure Code'),
      width: 70,
      dataIndex: 'code',
      key: 'code',
      ellipsis: true,
    },
    {
      title: t('Procedure Name'),
      width: 110,
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
    },
    {
      title: t('Actions'),
      dataIndex: 'code',
      key: 'code',
      align: 'center',
      width: 40,
      fixed: 'right',
      render: (text, record) => {
        return (
          <ActionIcon>
            <ActionIcon.Delete onClick={() => onRemove(record)} />
          </ActionIcon>
        );
      },
    },
  ];
};

export default useProcedureColumns;
